
import { Trek } from '@/lib/types/trek-types';
import { ArrowUp, Ruler, Calendar, Mountain } from 'lucide-react';

interface TrekStatsProps {
  trek: Trek;
}

const TrekStats = ({ trek }: TrekStatsProps) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6 mt-2">
      <div className="bg-card/40 backdrop-blur-sm p-4 rounded-lg border border-border/30 flex items-center">
        <ArrowUp className="h-5 w-5 mr-3 text-sky-500" />
        <div>
          <span className="text-sm text-muted-foreground block">Elevation</span>
          <span className="text-base font-medium">{trek.elevation} {trek.elevationUnit}</span>
        </div>
      </div>
      
      <div className="bg-card/40 backdrop-blur-sm p-4 rounded-lg border border-border/30 flex items-center">
        <Ruler className="h-5 w-5 mr-3 text-purple-500" />
        <div>
          <span className="text-sm text-muted-foreground block">Distance</span>
          <span className="text-base font-medium">{trek.distance} km</span>
        </div>
      </div>
      
      <div className="bg-card/40 backdrop-blur-sm p-4 rounded-lg border border-border/30 flex items-center">
        <Calendar className="h-5 w-5 mr-3 text-amber-500" />
        <div>
          <span className="text-sm text-muted-foreground block">Duration</span>
          <span className="text-base font-medium">{trek.duration} days</span>
        </div>
      </div>
      
      <div className="bg-card/40 backdrop-blur-sm p-4 rounded-lg border border-border/30 flex items-center">
        <Mountain className="h-5 w-5 mr-3 text-green-500" />
        <div>
          <span className="text-sm text-muted-foreground block">Best Season</span>
          <span className="text-base font-medium">{trek.bestSeason}</span>
        </div>
      </div>
    </div>
  );
};

export default TrekStats;
